const SellerId: React.FC<SellerIdProps> = ({ data }) => {
  const { seller_id } = data

  return <section>{seller_id}</section>
}

export default SellerId
